<div class="nav-header">
    <a routerLink="/admin" class="brand-logo ">
      <img [src]="header_logo" class="header-logo"/>
       <!-- <span >Property Handling</span> -->
    </a>
    <div class="nav-control" (click)="toggleSidebar()">
      <div [ngClass]="{'is-active':toggleVal, 'hamburger': true}">
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </div>
    </div>
  </div>